import React, { useEffect, useState } from 'react'

import {
	Button,
	Card,
	CardHeader,
	CardBody,
	CardTitle,
	FormGroup,
	Input,
	Row,
	Col,
	Label,
	FormFeedback,
} from "reactstrap";
import axios from "axios";
import useForm from "../../formValidator/userForm";
import "./styles.css";

import Loader from '../../components/Loader'

import { STATES, DISTRICTS, BLOCKS, GRAM_PANCHAYAT, CATEGORY, DEPARTMENT, SCHEME, APPLICATION } from '../../configs/urls'
import { getApi, postApi, putApi } from '../../services/api'
import { DATE_FORMATS } from '../../configs/constant'
import DatePicker from 'reactstrap-date-picker'
import * as moment from 'moment';
import { useHistory } from 'react-router-dom'
import { Multiselect } from 'multiselect-react-dropdown';

const ApplicationOperations = (props) => {

	const [isRequesting, setIsRequesting] = useState(false)
	const [actionTitle, setActionTitle] = useState('Add Application')
	const [dob, setDob] = useState(moment().toISOString())
	const [states, setStates] = useState([])
	const [districts, setDistricts] = useState([])
	const [blocks, setBlocks] = useState([])
	const [gramPanchayats, setGramPanchayats] = useState([])
	const [categories, setCategories] = useState([])
	const [departments, setDepartments] = useState([])
	const [schemes, setSchemes] = useState([])

	const history = useHistory()

	const [selectedCategories, setSelectedCategories] = useState([])
	const [selectedSchemes, setSelectedSchemes] = useState([])

	useEffect(() => {
		getAllData()
	}, [])

	const getAllData = () => {
		setIsRequesting(true);

		const state = getApi(STATES);
		const department = getApi(DEPARTMENT);
		const category = getApi(CATEGORY);

		axios
			.all([state, department, category])
			.then((res) => {

				if (res[0] && res[0].data) {
					setStates(res[0].data)
					params.state_id = 20 //Punjab default
					getDistricts(params.state_id)
				}

				if (res[1] && res[1].data) {
					setDepartments(res[1].data)
				}

				if (res[2] && res[2].data) {
					setCategories(res[2].data)
				}
			})
			.catch(() => {

			}).finally(() => {
				setIsRequesting(false)
			})
	};

	const getDistricts = (stateId) => {
		setIsRequesting(true);

		setBlocks([]);
		setGramPanchayats([]);
		updateSingleKey('district_id', -1);
		updateSingleKey('block_id', -1);
		updateSingleKey('gram_panchayat_id', -1);

		getApi(DISTRICTS, { state_id: stateId }).then(res => {
			setDistricts(res.data)
		}).catch(() => { }).finally(() => {
			setIsRequesting(false)
		})
	}

	const getBlocks = (districtId, stateId) => {
		setIsRequesting(true);
		getApi(BLOCKS, { district_id: districtId, state_id: stateId }).then(res => {
			updateSingleKey('block_id', -1);
			updateSingleKey('gram_panchayat_id', -1);

			setBlocks(res.data)
			setGramPanchayats([])
		}).catch(() => { }).finally(() => {
			setIsRequesting(false)
		})
	}

	const getGramPanchayat = (districtId, stateId, blockId) => {
		setIsRequesting(true);
		getApi(GRAM_PANCHAYAT,
			{ district_id: districtId, state_id: stateId, block_id: blockId }).then(res => {
				setGramPanchayats(res.data)
			}).catch(() => { }).finally(() => {
				setIsRequesting(false)
			})
	}

	const getSchemes = (categories) => {
		setSelectedSchemes([])
		if(categories.length == 0) {
			setSchemes([])
			return
		}
		
		setIsRequesting(true);

		const params = {
			category_ids: categories.map(category => category.id)
		}
		getApi(SCHEME, params).then(res => {
				setSchemes(res.data)
			}).catch(() => { }).finally(() => {
				setIsRequesting(false)
			})
	}

	const validate = (values) => {
		let errors = {};

		if (!values.applicant_name) {
			errors.applicant_name = "Applicant Name is required";
		}

		if (!values.care_of_name) {
			errors.care_of_name = "Father's/Wife's Name is required";
		}

		if (!dob) {
			errors.dob = "Date of birth is required";
		}

		if (!values.mobile_no) {
			errors.mobile_no = "Mobile number is required";
		}

		if (!values.state_id || values.state_id < 0) {
			errors.state_id = "Please select state";
		}

		if (!values.district_id || values.district_id < 0) {
			errors.district_id = "Please select district";
		}

		if (!values.block_id || values.block_id < 0) {
			errors.block_id = "Please select block";
		}

		if (!values.gram_panchayat_id || values.gram_panchayat_id < 0) {
			errors.gram_panchayat_id = "Please select grampanchayat";
		}

		if (selectedCategories.length == 0) {
			errors.categories = "Please select categories";
		}

		if (selectedSchemes.length == 0) {
			errors.schemes = "Please select schemes";
		}

		if (!values.address) {
			errors.address = "Address is required";
		}

		if (values.email && !/\S+@\S+\.\S+/.test(values.email)) {
			errors.email = "Email address is invalid.";
		}

		return errors;
	};

	const saveUpdateApplication = () => {
		const formData = params;
		formData['category_ids[]'] = selectedCategories.map(category => category.id)
		formData['scheme_ids[]'] = selectedSchemes.map(scheme => scheme.id)
		formData.dob = moment(dob).format(DATE_FORMATS.DATE_SERVER_FORMAT);
		setIsRequesting(true);

		if (props.match && props.match.params && props.match.params.application_id) {
			putApi(`${APPLICATION}/${props.match.params.application_id}`, formData).then((res) => {
				history.goBack()
			}, () => {

			}).finally(() => {
				setIsRequesting(false);
			});
		} else {
			postApi(APPLICATION, formData, true)
				.then(
					(res) => {
						history.goBack()
					},
					(err) => { }
				)
				.finally(() => {
					setIsRequesting(false);
				});
		}
	}

	const handleCategoriesAndSchemeChange = (list, key) => {
		if(key == 'scheme') {
			setSelectedSchemes(list || [])
		} else {
			setSelectedCategories(list || []);
			getSchemes(list || [])
		}
  };

	const { params, errors, handleChange, handleSubmit, updateSingleKey } = useForm(
		saveUpdateApplication,
		validate
	);

	return (
		<div className="content">
			<Loader isLoading={isRequesting} />
			<form onSubmit={handleSubmit}>
				<Card className="card-user">
					<CardHeader>
						<CardTitle tag="h5">{actionTitle}</CardTitle>
					</CardHeader>
					<hr />
					<CardBody>
						<Row>
							<Col className="pr-1" md="6">
								<FormGroup>
									<label>Applicant Name</label>
									<Input
										type="text"
										name="applicant_name"
										placeholder="Applicant Name"
										value={params.applicant_name || ""}
										onChange={handleChange}
										invalid={errors.applicant_name && errors.applicant_name.length > 0 ? true : false}
									/>
									<FormFeedback>{errors.applicant_name}</FormFeedback>
								</FormGroup>
							</Col>
							<Col className="pl-1" md="6">
								<FormGroup>
									<label>Father's/Wife's Name</label>
									<Input
										type="text"
										name="care_of_name"
										placeholder="Father's/Wife's Name"
										value={params.care_of_name || ""}
										onChange={handleChange}
										invalid={errors.care_of_name && errors.care_of_name.length > 0 ? true : false}
									/>
									<FormFeedback>{errors.care_of_name}</FormFeedback>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col className="pr-1" md="6">
								<FormGroup>
									<label>Date of birth</label>
									<DatePicker
										id="application-dob"
										className={errors.dob ? 'validation-border' : ''}
										dateFormat={DATE_FORMATS.DATE_ONLY_FORMAT}
										value={dob}
										onChange={(value, f) => setDob(value)} />
									<span className="validation-text">{errors.dob}</span>
								</FormGroup>
							</Col>
							<Col className="pl-1" md="6">
								<FormGroup>
									<label>Mobile no</label>
									<Input
										type="text"
										name="mobile_no"
										maxLength={10}
										placeholder="Mobile no"
										value={params.mobile_no || ""}
										onChange={handleChange}
										invalid={errors.mobile_no && errors.mobile_no.length > 0 ? true : false}
									/>
									<FormFeedback>{errors.mobile_no}</FormFeedback>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col className="pr-1" md="6">
								<FormGroup>
									<Label for="stateName">State Name</Label>
									<Input
										className="disable-field"
										type="select"
										name="state_id"
										id="stateName"
										value={params.state_id}
										onChange={(e) => {
											handleChange(e);
											getDistricts(e.target.value);
										}}
										invalid={errors.state_id && errors.state_id.length > 0 ? true : false}
									>
										<option value={-1}>Select State</option>
										{
											states.map(state => (
												<option key={state.id} value={state.id}>{state.name}</option>
											))
										}
									</Input>
									<FormFeedback>{errors.state_id}</FormFeedback>
								</FormGroup>
							</Col>
							<Col className="pl-1" md="6">
								<FormGroup>
									<Label for="districtName">District Name</Label>
									<Input
										type="select"
										name="district_id"
										id="districtName"
										value={params.district_id}
										onChange={(e) => {
											handleChange(e);
											getBlocks(e.target.value, params.state_id);
										}}
										invalid={errors.district_id && errors.district_id.length > 0 ? true : false}
									>
										<option value={-1}>Select District</option>
										{
											districts.map(district => (
												<option key={district.id} value={district.id}>{district.name}</option>
											))
										}
									</Input>
									<FormFeedback>{errors.district_id}</FormFeedback>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col className="pr-1" md="6">
								<FormGroup>
									<Label for="blockName">Block Name</Label>
									<Input
										type="select"
										name="block_id"
										id="blockName"
										value={params.block_id}
										onChange={(e) => {
											handleChange(e);
											getGramPanchayat(params.district_id, params.state_id, e.target.value);
										}}
										invalid={errors.block_id && errors.block_id.length > 0 ? true : false}
									>
										<option value={-1}>Select Block</option>
										{
											blocks.map(block => (
												<option key={block.id} value={block.id}>{block.name}</option>
											))
										}
									</Input>
									<FormFeedback>{errors.block_id}</FormFeedback>
								</FormGroup>
							</Col>
							<Col className="pl-1" md="6">
								<FormGroup>
									<Label for="gpName">GramPanchayat Name</Label>
									<Input
										type="select"
										name="gram_panchayat_id"
										id="gpName"
										value={params.gram_panchayat_id}
										onChange={handleChange}
										invalid={errors.gram_panchayat_id && errors.gram_panchayat_id.length > 0 ? true : false}
									>
										<option value={-1}>Select GramPanchayat Name</option>
										{
											gramPanchayats.map(district => (
												<option key={district.id} value={district.id}>{district.name}</option>
											))
										}
									</Input>
									<FormFeedback>{errors.gram_panchayat_id}</FormFeedback>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col className="pr-1" md="6">
								<FormGroup>
									<label>Email (optional)</label>
	
									<Input
										type="text"
										name="email"
										placeholder="Email"
										value={params.email || ""}
										onChange={handleChange}
										invalid={errors.email && errors.email.length > 0 ? true : false}
									/>
									<FormFeedback>{errors.email}</FormFeedback>
								</FormGroup>
							</Col>
							<Col className="pl-1" md="6">
								<FormGroup>
									<Label for="gpName">Categories</Label>
									<Multiselect
										options={categories}
										selectedValues={selectedCategories}
										className={errors.categories ? 'validation-border' : ''}
										onSelect={(selectedList, selectedItem) =>
											handleCategoriesAndSchemeChange(selectedList, 'category')
										}
										placeholder="Select Categories"
										onRemove={(selectedList, removedItem) =>
											handleCategoriesAndSchemeChange(selectedList, 'category')
										}
										displayValue="name"
									/>
									<span className="validation-text">{errors.categories}</span>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col className="pr-1" md="6">
								<FormGroup>
									<Label for="gpName">Schemes</Label>
									<Multiselect
										options={schemes}
										selectedValues={selectedSchemes}
										onSelect={(selectedList, selectedItem) =>
											handleCategoriesAndSchemeChange(selectedList, 'scheme')
										}
										placeholder="Select Schemes"
										onRemove={(selectedList, removedItem) =>
											handleCategoriesAndSchemeChange(selectedList, 'scheme')
										}
										className={errors.schemes ? 'validation-border' : ''}
										displayValue="name"
									/>
									<span className="validation-text">{errors.schemes}</span>
								</FormGroup>
							</Col>
							<Col className="pl-1" md="6">
								<FormGroup>
									<Label for="address">Address</Label>
									<Input
										type="textarea"
										name="address"
										invalid={errors.address && errors.address.length > 0 ? true : false}
										value={params.address}
										onChange={handleChange}
									/>
									<FormFeedback>{errors.address}</FormFeedback>
							</FormGroup>
							</Col>
						</Row>
						<Row>
							<div className="update ml-auto mr-auto">
								<Button
									className="btn-round"
									color="primary"
									type="submit"
								>
									{actionTitle}
								</Button>
							</div>
						</Row>
					</CardBody>
				</Card>
			</form>
		</div>
	)
}

export default ApplicationOperations